/** Coerce a stored-as-string boolean to a real `boolean`.
 *
 * The legacy `settings` table stores boolean knobs as `"0"` / `"1"`
 * strings (and a handful of legacy rows use `"true"` / `"false"` /
 * `"on"` / `"off"`). The Tktic React surfaces read these through
 * the public-settings JSON, where the values arrive as strings.
 *
 * Used by:
 *   - Admin Settings page knob renderer
 *   - Admin Performance tuning-knobs grid
 *   - Public viewer (M11) — gates the season-view Live CTA on
 *     `live_enabled`, the download buttons on `downloads_enabled`,
 *     etc.
 *
 * Empty string → false (legacy: an unset knob serializes to "" and
 * historically meant "off"). Unknown types fall through to
 * `Boolean(value)` so numbers / nullables behave as JS expects.
 */
export function coerceBool(value: unknown): boolean {
  if (typeof value === "boolean") return value;
  if (typeof value === "string") {
    const v = value.trim().toLowerCase();
    if (v === "1" || v === "true" || v === "on" || v === "yes") return true;
    if (v === "0" || v === "false" || v === "off" || v === "no" || v === "")
      return false;
  }
  return Boolean(value);
}
